import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import clsx from 'clsx'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import {
  Container,
  useMediaQuery,
  useTheme,
  Grid,
  Typography,
} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import Link from '../Link/Link'
import CMSText, { isPrismicText } from '../Global/CMSText'
import Button from '../../components/Button/Button'
import useTakeBackStyle from '../../components/TakeBack/TakeBack.style'
import { downloadURI, columnLayout } from '../../utils/utils'

type Tprops = {
  takeback: any
  t: any
  takeBack: any
  showVoucherPrintingButton: boolean
}

const mapStateToProps = (state) => ({
  takeBack: state.takeBack,
})

const mapDispatchToProps = {}

const TakeBackThirdStep = ({
  takeback,
  t,
  takeBack,
  showVoucherPrintingButton,
}: Tprops) => {
  const classes = useTakeBackStyle()
  const theme = useTheme()
  const pageBody = takeback?.data?.body ? takeback?.data?.body : []
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const orderNumber = takeBack?.response?.id
  const { trackPageView } = useMatomo()

  useEffect(() => {
    trackPageView({ documentTitle: 'Take Back Program - Third Step' })
    window?.scrollTo(0, 0)
  }, [])

  return (
    <div className={clsx(classes.takeBackThirdStep, 'takeBack__thirdStep')}>
      <div className={classes.confirmationIcon}>
        <CheckCircleIcon />
      </div>
      <Typography
        variant="h3"
        component={'div'}
        className={'takeBack__thirdStep_confirmation_title'}
      >
        <CMSText
          asText
          data={takeback?.data?.confirmation_title}
          defaultText={t('texts:takeBack:confirmation_title')}
        />
      </Typography>
      <Typography
        variant={'body2'}
        component={'div'}
        className={clsx(
          'takeBack__thirdStep_confirmation_desc',
          classes.confirmationText
        )}
      >
        <span>
          <CMSText
            asText
            data={takeback?.data?.your_order_number}
            defaultText={t('texts:takeBack:your_order_number')}
          />
        </span>
        <span>
          &nbsp;
          {orderNumber}
          &nbsp;
        </span>
        <span>
          <CMSText
            data={takeback?.data?.confirmation_text}
            defaultText={t('texts:takeBack:confirmation_text')}
          />
        </span>
      </Typography>
      {pageBody.length !== 0 &&
        pageBody.map((item, index) => {
          const gridItemWidth = columnLayout(item.items.length)
          return (
            <section
              key={`${item.slice_type}-${index}`}
              id={`section-${item.slice_type}-${index}`}
              className={clsx(classes.section, 'takeBack__thirdStep__section')}
            >
              <Container>
                <Grid
                  container
                  spacing={isMobile ? 1 : 3}
                  justify="center"
                  wrap={isMobile ? 'wrap' : 'nowrap'}
                >
                  {item.items?.map((el, index) => {
                    return (
                      <Grid
                        key={index}
                        id={`column-${index}`}
                        item
                        xs={12}
                        lg={gridItemWidth}
                      >
                        <div
                          style={{ textAlign: item?.primary?.text_align }}
                          className={'step__explication__title'}
                        >
                          <CMSText data={el.title} />
                        </div>
                        <div style={{ textAlign: item?.primary?.text_align }}>
                          <CMSText data={el.text} />
                        </div>
                      </Grid>
                    )
                  })}
                </Grid>
              </Container>
            </section>
          )
        })}
      {showVoucherPrintingButton && takeBack?.response?.url && (
        <div>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={() =>
              downloadURI(
                takeBack?.response?.url,
                `${process.env.STORE}_label_second_hand_${orderNumber}`
              )
            }
          >
            <CMSText
              asText
              data={takeback?.data?.voucher_printing_button}
              defaultText={t('texts:takeBack:voucher_printing_button')}
            />
          </Button>
        </div>
      )}

      {isPrismicText(takeback?.data?.shop_link_text) && (
        <Link href={'/shop'}>
          <a>
            <Button variant="contained" color="secondary" size="small">
              <CMSText
                asText
                data={takeback?.data?.shop_link_text}
                defaultText={t('texts:takeBack:go_to_shop')}
              />
            </Button>
          </a>
        </Link>
      )}
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(TakeBackThirdStep)
